module.exports = __webpack_public_path__ + "259219f1b0541a8eb4fbfa8d3ff90cc9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-13.png
// module id = 3027
// module chunks = 0